module.exports = __webpack_public_path__ + "img/services-solution-icon.3c06e028.svg";